import Axios from './axiosClient'
import { API_ENDPOINT } from '../constants/apis'
import { AxiosResponse } from 'axios'
import type { MultiOrgGroup, MultiOrgGroupsResponse } from '../types'

export const getMultiOrgGroups = (): Promise<
  AxiosResponse<MultiOrgGroupsResponse>
> => {
  return Axios.get(`${API_ENDPOINT}/multi-org`)
}

export const getMultiOrgGroup = (
  id: string
): Promise<AxiosResponse<MultiOrgGroup>> => {
  return Axios.get(`${API_ENDPOINT}/multi-org/${id}`)
}
